const genres = [
  "Action",
  "Adventure",
  "Animation",
  "Biography",
  "Comedy",
  "Crime",
  "Documentary",
  "Drama",
  "Family",
  "Fantasy",
  "Fiction",
  "Film-Noir",
  "Game Show",
  "History",
  "Horror",
  "Music",
  "Musical",
  "Mystery",
  "News",
  "Reality TV",
  "Romance",
  "Sci-Fi",
  "Superhero",
  "Sport",
  "Talk Show",
  "Thriller",
  "War",
  "Western",
];

export default genres;
